// removed by extract-text-webpack-plugin
module.exports = {"root":"_3ZSlq","label":"_2ztf3","content":"_3Pfcq","highlight":"_2yc-u","miniClass":"_3MV62","description":"_R8tEI","quota":"_lq6_L","number":"_1XCT7","name":"_2izAO","price":"_w1ANP","symbol":"_DagB0"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/components/Token/Token.scss
// module id = 1338
// module chunks = 3